<template>
  <div class='xy-content-module'>
    <div class='xy-content-title xy-flex xy-between xy-center'>
      <div><!--这里是按钮 --></div>
      <div><!--这里是右侧的筛选 --></div>
    </div>
    <div class='xy-content-body'>
      <!-- 顶部名片 -->
      <div class="myCard">
        <div class="card-tit">
          <div class="my-icon">
            <div class="img-icon" v-if="userIcon">
              <img :src="userIcon" alt="">
            </div>
            <div class="name-icon" :class="sex === 1 ? 'man' : 'woman'" v-else>
              {{xy.showName(userName)}}
            </div>
            <div class="my-user">
              {{userName}}
            </div>
          </div>
          <div class="time">{{xy.moment(date).format('YYYY-MM-DD')}}  {{weekNow}}</div>
        </div>
        <div class="card-main">
          <div class="today-score">{{totalScore}} </div>
          <div class="today-text">今日得分</div>
        </div>
      </div>
      <!-- 得分列表 -->
      <div class="assessView null-data" v-if="list.length === 0 && isLoad">
        <img src="@/assets/common/moblie-no-data.png" />
        <div>今日暂无评价。</div>
      </div>
      <van-pull-refresh v-model="isLoading" class="visitlists-refresh" @refresh="onRefresh" v-else>
        <!-- 释放提示 -->
        <template #pulling>
          <span style="font-size:14Px">下拉即可刷新...</span>
        </template>
        <!-- 下拉提示 -->
        <template #loosing>
          <span style="font-size:14Px">释放即可刷新...</span>
        </template>
        <van-list
        class="refreshWrap"
        v-model="isRefresh"
        :finished="finished"
        finished-text="没有更多了"
        loading-text=" "
        @load="onLoad"
        >
        <ul class="score-list">
          <li v-for="(item, index) in list" :key="index">
            <div class="score-card-tit">
              <p>{{item.IndexManagementName}} </p>
              <p>{{item.EvaTime}} </p>
            </div>
            <div class="rate-score" v-show="ScoreType === 1">
              <img src="./img/rate.png" alt="">
              <div class="score">{{item.Score}} </div>
            </div>
            <div class="rate-score" v-show="ScoreType === 0">
              <div class="score" style="color: #FF0A0A">{{item.Score}} </div>
            </div>
          </li>
        </ul>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup v-model="showCover">
      <div class="mask">
        <img src="./img/notice.png" alt="">
        <div class="text">为了更好的使用，请您横屏使用</div>
        <div class="close" @click="showCover =  false">
           知道了
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import { Toast } from 'vant'
  export default {
    name: '',
    data () {
      return {
        showCover:false,
        num:0,
        pageIndex: 1,
        pageSize: 15,
        list: [],
        totalScore: 0,
        weekNow: ' ',
        date: new Date(),
        userName: '',
        userIcon: '',
        sex: '',
        onloaded:true,
        isLoading: false, //下拉刷新状态
        isRefresh: false, // 是否加载中
        finished: false, // 加载是否完成
        isLoad: false,
        ScoreType: 0
      }
    },
    created () {
      this.getUserInfo()
      this.dateNow()
    },
    mounted() {
        window.addEventListener("resize", this.watch, false);
        this.watch();
    },
    beforeDestroy() {
    // 移除监听
      window.removeEventListener("resize", this.watch, false);
    },
    methods: {
      watch(){
          // 判断横竖屏
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          if(height>width){
            this.showCover = true
            this.num = 0  //竖屏
          }else{
            this.num =  1 //横屏幕
            this.showCover = false
          }
      },
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      dateNow() {
        let now = this.xy.moment(this.date).isoWeekday()
        switch (now) {
          case 1: 
            this.weekNow = '星期一'
            break
          case 2: 
            this.weekNow = '星期二'
            break
          case 3: 
            this.weekNow = '星期三'
            break
          case 4: 
            this.weekNow = '星期四'
            break
          case 5: 
            this.weekNow = '星期五'
            break
          case 6: 
            this.weekNow = '星期六'
            break
          case 7: 
            this.weekNow = '星期日'
            break
        }
      },
      onLoad(){
        if(this.num !== 0){
          if (this.onloaded){
            this.onLoadlist()
          }
        }
        
      },
     //获取接口数据
      async onLoadlist(){
          await this.getQuestionnaires();
          // 加载状态结束
          this.isRefresh = false;
          this.pageIndex++;   
      },
      //下拉加载
      onRefresh() {
          this.pageIndex = 1;
          this.isLoading = false;
          this.list = []
          this.finished = false;
          this.onLoadlist()
      },
      async getQuestionnaires() {
        this.loading()
        let res = await this.xyapi.get(`${this.xyMApi}/eva/api/MoralEducationStatisticsByPad/GetMyEVAStudentByPad`, {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        })
        Toast.clear()
        if (res.success) {
          // 将新数据与老数据进行合并
          if (res.data === null) {
            this.finished = true
            return
          }
          this.ScoreType = res.data.ScoreType
          this.totalScore = res.data.TotalScore
          this.list = this.list.concat(res.data.data?res.data.data:[])
          this.isLoad = true
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list === null || this.list.length === 0 || this.list.length >= res.data.totalRecords) {
            this.finished = true
            return
          }
        } else {
          this.finished = true
        }
      },
      async getUserInfo() {
        let res = await this.xyapi.get(this.xyMApi + '/base/api/Users/CurUserInfo')
        if (res.data) {
          this.userName = res.data.FullName
          this.userIcon = res.data.Icon
          this.sex = res.data.Sex
        }
      }
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-list__finished-text{
    font-size: 14Px;
}
/deep/ .van-pull-refresh, /deep/ .van-pull-refresh__track {
    min-height: 270px;
}
.xy-content-body {
  margin: 20px;
}
.assessView {
  width: 100%;
  height: 190px;
}
.null-data {
  margin-top: 90px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.man {
  background: #4196ff;
}
.woman {
  background: #FF81AC;
}
.myCard {
  width: 984px;
  height: 138px;
  background: url('./img/bluebg.png') no-repeat;
  border-radius: 4px;
  position: relative;
  padding: 10px 10px 0 14px;
  font-size: 14px;

  .card-tit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .my-icon {
      display: flex;
      align-items: center;
      .img-icon {
        img {
          border-radius: 50%;
          width: 30px;
          height: 30px;
          border: 2px solid #759eff;
          margin-right: 5px;
        }
      }
      .name-icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid #759eff;
        margin-right: 5px;
        color: #fff;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
      }
      .my-user {
        color: rgba(255,255,255,0.9);
      }
    }
    .time {
      color: rgba(255,255,255,0.85);
    }
  }
  .card-main {
    text-align: center;
    color: #fff;
    .today-score {
      font-size: 40px;
      height: 52px;
    }
    .score-text {
      color: rgba(255,255,255,0.85);
    }
  }
}
.score-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    width: 487px;
    height: 100px;
    background: #fff;
    border-radius: 4px;
    margin-top: 10px;
    padding: 15px 15px 0 20px;
    font-size: 14px;
    .score-card-tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p:nth-child(1) {
        font-size: 16px;
        color: rgba(26,26,26,0.85);
        font-weight: 500;
      }
      p:nth-child(2) {
        color: rgba(26,26,26,0.42);
      }
    }
    .rate-score {
      display: flex;
      align-items: center;
      margin-top: 20px;
      img {
        margin-right: 5px;
      }
      div {
        color: rgba(26,26,26,0.85);
      }
    }
  }
}
.showCover{
  /deep/ .van-popup{
  overflow-y: inherit;
  }
}
.mask{
  width: 600px;
  height: 365px;
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  img{
    position: absolute;
    top: -82px;
    left: 50%;
    width:162px;
    height: 202px;
    transform: translate(-50%,7px)
  }
  .text{
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #2b2b2b;
    padding-top: 141px;
  }
  .close{
    margin:70px auto;
    width: 200px;
    height: 70px;
    background: #1677ff;
    border-radius: 35px;
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color:#fff;
    text-align: center;
    line-height: 70px;
  }
}
</style>
